const DISALLOWED_TAGS = new Set([
  "meta",
  "title",
  "base",
  "html",
  "head",
  "body", // 嵌套 body
  "meta[id='xtool-head-sentinel']"
]);
// 检查一次
function checkBodyInvalidTags() {
  const invalidElements = [];
  DISALLOWED_TAGS.forEach(tag => {
    const found = document.body.querySelectorAll(tag);
    if (found.length > 0) {
      invalidElements.push({
        tag,
        count: found.length,
        elements: Array.from(found).map(el => el.outerHTML.slice(0, 200)) // 截断显示内容
      });
    }
  });
  if (invalidElements.length > 0) {
    // 上报到 sentry
    Sentry?.captureMessage("Invalid elements found inside <body>", {
      level: "warning",
      tags: {
        issue_type: "html_structure",
        body_invalid_tags: invalidElements.map(i => `${i.tag}:${i.count}`).join(",")
      },
    });
  }
  return invalidElements;
}
// 页面加载完后初次检测
window.addEventListener("load", () => {
  checkBodyInvalidTags();
});